
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'


export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast,
Selector,
Grid,
GridItem,
GroupTitle,
Cell,
FormPreview
},
name: 'workExp',
data () {
return {
experience: [],
delbutton: [{
style: 'primary',
text: '删除',
onButtonClick: (name) => {
this.delExp(name)
}
}]
}
},
methods: {
delExp (exp) {
for (var i in this.experience) {
if ((this.experience[i].company + this.experience[i].starttime + this.experience[i].endtime + this.experience[i].title) === exp) {
this.experience.splice(i, 1)
break
}
}
console.log(this.experience)
},
addExp () {
this.$router.push({name: 'singleWorkExp'})
},
save () {
this.$router.push({name: 'expertInfo'})
}
},
beforeRouteLeave (to, from, next) {
if (to.name === 'expertInfo' || to.name === 'singleWorkExp') {
let expertdata = localStorage.getItem('expertdata')
if (expertdata != null) {
var data = JSON.parse(expertdata)
data.experience = this.experience
expertdata = JSON.stringify(data)
localStorage.setItem('expertdata', expertdata)
}
} else {
localStorage.removeItem('expertdata')
}
next()
},
created () {
let expertdata = localStorage.getItem('expertdata')
if (expertdata != null) {
var data = JSON.parse(expertdata)





data.experience.sort(function (a, b) {
return a.endtime < b.endtime ? 1 : -1
})





this.experience = data.experience
}
}
}



// WEBPACK FOOTER //
// ./src/components/workExp.vue